export default "__VITE_ASSET__64597471__"